import Vue from 'vue'
import { login, getInfo, logout } from '@/api/login'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          // 存储token 设置过期时间
          const result = response
          Vue.ls.set(ACCESS_TOKEN, result.access_token, result.expires_in * 1000)
          commit('SET_TOKEN', result.access_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const result = response.data
          const role = {
            permissions: result.permissions
          }
          commit('SET_ROLES', role)
          commit('SET_INFO', result.sysUser)
          commit('SET_NAME', { name: result.sysUser.username, welcome: welcome() })
          commit('SET_AVATAR', result.sysUser.avatar)

          resolve(role)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        logout(state.token).then(() => {
          commit('SET_ROLES', [])
          Vue.ls.remove(ACCESS_TOKEN)
          Vue.ls.remove('TENANT_ID')
          commit('SET_TOKEN', '')
          resolve()
        }).catch(() => {
          commit('SET_ROLES', [])
          Vue.ls.remove(ACCESS_TOKEN)
          Vue.ls.remove('TENANT_ID')
          commit('SET_TOKEN', '')
          resolve()
        })
      })
    },
    DelToken ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_ROLES', [])
        Vue.ls.remove(ACCESS_TOKEN)
        commit('SET_TOKEN', '')
        Vue.ls.remove('TENANT_ID')
        resolve()
      })
    }

  }
}

export default user
